import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

async function deleteSubTopic(id: string) {
  const { error } = await apiClient
    .from('topics')
    .delete()
    .eq('id', id)

  if (error) {
    throw error
  }
}

export function useDeleteTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (topicId: string) => deleteSubTopic(topicId),
    onSuccess: (_data, topicId) => {
      enqueueSnackbar('Sujet supprimé.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(false) })
      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(true) })
      queryClient.invalidateQueries({ queryKey: keys.topicListPagedAll() })
      queryClient.invalidateQueries({ queryKey: keys.topic(topicId) })
      queryClient.invalidateQueries({ queryKey: keys.subTopicList() })
    }
  })
}
